import React from "react";
import { FormattedMessage } from "react-intl";

const ModalFooter = ({ handleConfirm, confirmButtonLabel, disabled }) => (
  <div
    className={`modal-footer${disabled ? " disabled" : ""}`}
    style={{ marginTop: 10 }}
    onClick={!disabled ? handleConfirm : () => {}}
  >
    {confirmButtonLabel}
  </div>
);

export default ModalFooter;
